import { PAGOS_VENTAS } from '../actions/types';

const initialState = {
    cliente: null,
    resumen: null,
    ventas: [],
    pagos: [],
    loadingBalance: false,
    error: null
};

export default function pagosVentasReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case PAGOS_VENTAS.BALANCE_CARGANDO:
            return {
                ...state,
                loadingBalance: true
            };

        case PAGOS_VENTAS.BALANCE:
            return {
                ...state,
                cliente: payload?.cliente || null,
                resumen: payload?.resumen || null,
                ventas: Array.isArray(payload?.ventas) ? payload.ventas : [],
                pagos: Array.isArray(payload?.pagos) ? payload.pagos : [],
                loadingBalance: false,
                error: null
            };

        case PAGOS_VENTAS.LIMPIAR_BALANCE:
            return { ...initialState };

        case PAGOS_VENTAS.ERROR:
            return { ...state, loadingBalance: false, error: payload };

        default:
            return state;
    }
}
